// extracted by mini-css-extract-plugin
export default {"wrap":"Wrapper_wrap__3gbv2"};